import React, { useState } from 'react'
import {
    Input,
    Button,
    Form,
    FormGroup,
    Label,
    FormFeedback
} from "reactstrap"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import { useDispatch } from 'react-redux'
import { uploadKnowledgeCenterDoc } from 'store/actions'


const UploadFile = ({ toggleUploadFileModal }) => {
    const dispatch = useDispatch();

    const [selectedFile, setSelectedFile] = useState({
        name: "",
        file: ""
    })
    const validation = useFormik({
        // enableReinitialize : use this  flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            file_type: "" || "",
            description: "" || "",
        },
        validationSchema: Yup.object({

            file_type: Yup.string().required("Please select file type."),
            description: Yup.string().required("Please Enter description"),
        }),
        onSubmit: (values) => {
            //  dispatch(loginSuperUser(values, props.router.navigate))
            dispatch(uploadKnowledgeCenterDoc({ file_name: selectedFile.name, KnowledgeCenter: selectedFile.file, ...values }))
            validation.resetForm();
            toggleUploadFileModal();
        },
    })

    return (
        <div>
            {/* {Loading ?
        <div className="w-100 text-center">
          <Spinner />
          <p>Please Wait.. File is uploading...</p>
        </div> : */}
            <>
                <Form onSubmit={(e) => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                }}>
                    <FormGroup>
                        <Label for={"KnowledgeCenter"}>Upload File</Label>
                        <Input
                            type="file"
                            name="KnowledgeCenter"
                            id="KnowledgeCenter"
                            //value={selectedFile}
                            onChange={(e) => {
                                setSelectedFile({ ...selectedFile, file: e.target.files[0], name: e.target.files[0].name })
                            }
                            }
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label for={"file_type"}>Select File Type</Label>
                        <Input
                            type='select'
                            placeholder='Select File Type'
                            name='file_type'
                            id='file_type'
                            value={validation.values.file_type}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                                validation.touched.file_type &&
                                    validation.errors.file_type
                                    ? true
                                    : false
                            }
                        >
                            <option value={""} selected>Select Type</option>
                            <option value={"brouchers"}>Broucher</option>
                            <option value={"circulars"}>Circular</option>
                        </Input>

                        {validation.touched.file_type &&
                            validation.errors.file_type ? (
                            <FormFeedback type="invalid">
                                {validation.errors.file_type}
                            </FormFeedback>
                        ) : null}
                    </FormGroup>

                    <FormGroup>
                        <Label for={"description"}>Description</Label>
                        <Input
                            type='textarea'
                            name='description'
                            id='fileDescription'
                            col={"4"}
                            value={validation.values.description}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                                validation.touched.description &&
                                    validation.errors.description
                                    ? true
                                    : false
                            }
                        />

                        {validation.touched.description &&
                            validation.errors.description ? (
                            <FormFeedback type="invalid">
                                {validation.errors.description}
                            </FormFeedback>
                        ) : null}
                    </FormGroup>


                    <FormGroup className="my-2">
                        <Button
                            color="primary"
                            className="me-2"
                            type='submit'
                        >
                            Upload
                        </Button>
                        <Button color="danger" className="me-2" >
                            Cancel
                        </Button>

                    </FormGroup>
                </Form>
            </>

            {/* } */}
        </div >
    )
}

export default UploadFile